"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NICKNAME_MAX_LENGTH = exports.NICKNAME_MIN_LENGTH = exports.MEDAL_PROPS = exports.AVATAR_TRAITS = exports.AVATAR_OPTIONS = exports.CUSTOM_CLOTHING_BASE = exports.SUIT_COLORS = exports.COLORED_PROPS = exports.RANDOM_EXCLUDED_TOPS = exports.OPT_IN_HEADWEAR = exports.HAIR_COVERING_HEADWEAR = void 0;
const HAIR = [
    'bob', 'bun', 'curly', 'curvy', 'dreads', 'fro', 'froBand', 'longButNotTooLong', 'miaWallace', 'shavedSides',
    'straight02', 'straight01', 'straightAndStrand', 'dreads01', 'dreads02', 'frizzle', 'shaggy', 'shaggyMullet',
    'shortCurly', 'shortFlat', 'shortRound', 'shortWaved', 'sides', 'theCaesar', 'theCaesarAndSidePart', 'bigHair',
];
/** Headwear that covers the head completely, so the hairstyle is not drawn. */
exports.HAIR_COVERING_HEADWEAR = ['hijab', 'turban'];
/**
 * Religious headwear is a personal choice: offered in the editor, never handed
 * out by the random generator.
 */
exports.OPT_IN_HEADWEAR = ['hijab', 'turban', 'kippah'];
/** Hairstyles left out of generated avatars; they can still be chosen. */
exports.RANDOM_EXCLUDED_TOPS = ['theCaesar', 'theCaesarAndSidePart', 'bigHair'];
/** Props drawn in `propColor`; the editor offers the color picker only for these. */
exports.COLORED_PROPS = ['apron', 'scarf'];
exports.SUIT_COLORS = ['262e33', '3c4f5c', '2f3e5c', '5a4636', '4b3b5c'];
/** Clothing ids we draw ourselves on top of a stock Avataaars base. */
exports.CUSTOM_CLOTHING_BASE = {
    turtleneck: 'shirtCrewNeck',
    suit: 'blazerAndShirt',
};
/** Clothing and glasses frames share one palette. */
const CLOTHES_COLORS = [
    '3c4f5c', '262e33', '2f3e5c', '5a4636', '4b3b5c', '929598', 'e6e6e6', 'f2eee6', 'c9a27e', '8aa77b',
    'c76b4a', '6b4f8a', '5199e4', 'b1e2ff', 'a7ffc4', 'ffafb9', 'ffffb1', 'ff5c5c',
];
/**
 * Every value a stored avatar may hold, per trait. The first entry of each list
 * is what an unknown id falls back to when drawing.
 */
exports.AVATAR_OPTIONS = {
    skin: ['edb98a', 'ffdbb4', 'ffe8d4', 'fd9841', 'd08b5b', 'ae5d29', '614335'],
    top: ['none', ...HAIR],
    headwear: ['none', 'hat', 'hijab', 'turban', 'kippah'],
    hairColor: ['2c1b18', '4a312c', '724133', 'a55728', 'b58143', 'd6b370', 'ecdcbf', 'e8e1e1', 'c93305', 'f59797'],
    hatColor: ['3c4f5c', '262e33', '929598', 'e6e6e6', 'c9a27e', '8aa77b', 'c76b4a', '5199e4', 'ffafb9', '6b4f8a'],
    eyes: ['default', 'happy', 'wink', 'side', 'squint'],
    eyebrows: ['default', 'defaultNatural', 'flatNatural', 'raisedExcited', 'raisedExcitedNatural', 'upDown', 'upDownNatural'],
    mouth: ['default', 'smile', 'twinkle', 'serious'],
    facialHair: ['none', 'beardLight', 'beardMedium', 'beardMajestic', 'moustacheFancy', 'moustacheMagnum'],
    glasses: ['none', 'prescription01', 'prescription02', 'round', 'wayfarers'],
    glassesColor: CLOTHES_COLORS,
    clothing: ['shirtCrewNeck', 'shirtVNeck', 'collarAndSweater', 'blazerAndShirt', 'blazerAndSweater', 'turtleneck', 'suit'],
    clothesColor: CLOTHES_COLORS,
    accentColor: ['c76b4a', 'e2b04a', '3f5a7a', '8aa77b', '9b5c8a', 'f06292', '262e33'],
    prop: ['none', 'swatches', 'paintChip', 'camera', 'coffeeMug', 'apron', 'scarf', 'medalGold', 'medalSilver', 'medalBronze'],
    propColor: ['c76b4a', 'e2b04a', '3f5a7a', '8aa77b', '9b5c8a', 'f06292', 'e0cfae', '5c6b7a', '3b3b3b'],
    background: [
        'fde2ea-f9c5d5', 'e8e0ff-d4c6ff', 'dcefe6-bfe0cf', 'fdf0d5-f8dfae', 'dbeafe-bdd6fb', 'f5e1d3-ecc9b1',
        'e3f4f4-c4e6e6', 'f1e4f3-e0c9e4', 'fde2ea-e8e0ff', 'dcefe6-fdf0d5', 'dbeafe-f1e4f3', 'f5e1d3-fde2ea',
    ],
};
exports.AVATAR_TRAITS = Object.keys(exports.AVATAR_OPTIONS);
/** Props that need a medal of that tier before they can be saved. */
exports.MEDAL_PROPS = {
    medalGold: 'gold',
    medalSilver: 'silver',
    medalBronze: 'bronze',
};
exports.NICKNAME_MIN_LENGTH = 3;
exports.NICKNAME_MAX_LENGTH = 20;
